import { AsyncState, loadingAsyncState, unloadedAsyncState } from "widgets-for-react"
import { getCollectionPage } from "../../../../custom_api/api"
import { AdviceFilter, AdviceSortMethod, AdviceType } from "../../../../custom_api/bookarang/types"
import { WiseBook, WiseBookDetails } from "../../../../custom_api/wise/types"
import { CollectionPageProps } from "../../../pages/collection_page"
import { BranchState } from "../../application"
import { UpdateFilterValue } from "./FilterSelector/FilterSelectorState"
import { List } from "immutable"

import { Availability, CollectionItem } from "../../../../../Shared/backendApi/generated"

export type BookHighlight = {
  book: WiseBook
} & (
    { availability: 'unknown' } |
    { availability: 'none' | 'somewhere' | 'elsewhere', qrDataUrl: string } |
    { availability: 'here', location: string, code: string }
  )

export const initialBookHighlight: BookHighlight = { book: null, availability: 'unknown' }

export type AdviceProps = AdviceState & BranchState

export interface HighlightState {
  highlightedBook: WiseBook
  highlightedBookQR: string
  highlightedBookDetails: AsyncState<WiseBookDetails>
  highlightedBookAvailability: AsyncState<List<Availability>>
}

export type AdviceState = {
  collectionPage: AsyncState<CollectionPageProps>
  selectedBook: AsyncState<CollectionItem>
  adviceType: AdviceType
  selectedPrompt: string
  filterQueryParams: string
  advice: AsyncState<WiseBook[]>
  filters: AsyncState<AdviceFilter[]>
  sortMethod: AdviceSortMethod
  title: string
  author: string
  routePath: string
  isKioskMode: boolean
} & HighlightState

export const initialHighlightState: HighlightState = {
  highlightedBook: null,
  highlightedBookQR: null,
  highlightedBookDetails: unloadedAsyncState<WiseBookDetails>(),
  highlightedBookAvailability: unloadedAsyncState<List<Availability>>()
}

export const initialAdviceState: AdviceState = {
  collectionPage: loadingAsyncState(() => getCollectionPage()),
  selectedBook: unloadedAsyncState<CollectionItem>(),
  adviceType: "book",
  selectedPrompt: "",
  filterQueryParams: "",
  advice: unloadedAsyncState(),
  filters: unloadedAsyncState(),
  sortMethod: "match",
  title: "",
  author: "",
  routePath: "",
  isKioskMode: false,
  ...initialHighlightState
}

// Layout receives simplified highlight props
export type AdviceLayoutProps = Omit<AdviceProps, keyof HighlightState> & {
  highlight: BookHighlight
  updateFilterValue: UpdateFilterValue
  updateSortMethod: (method: AdviceSortMethod) => void
  setHighlight: (id: string) => void
  resetHighlight: () => void
}
